import { createFileRoute } from "@tanstack/react-router";
import { DistributionPackagesPage } from "@/features/tenant/DistributionPackagesPage";

export const Route = createFileRoute("/app/tenant/packages")({ component: DistributionPackagesPage });
